/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for the Conversations capability.
 */
export const CONVERSATIONS_CAPABILITY_STRINGS = {
  altTitle: `conversations`,
  dialogBlurb: `lets you manage and control AI powered chatbots used in your digital experiences.`,
  dialogBullet1: `Review conversation history ratings and tags for precise feedback for improvement.`,
  dialogBullet2: `Control information and knowledge base.`,
  dialogBullet3: `Give guidance on responses to questions including language to use, response structure and templates.`,
  subtitle: `Manage and control AI powered chatbots used in your digital experiences.`,
  title: `Conversations`,
};
